import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { tab: String } // e.g. "custom" or "imo"
  static targets = ["refSpeed", "refSpeedHidden", "iceClass", "imoShipType"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    this.dispatch("toggleSelected", { detail: {} })
  }

  updateHidden(event) {
    const newValue = event.target.value
    if (this.hasRefSpeedHiddenTarget) {
      this.refSpeedHiddenTarget.value = newValue
    }
  }

  syncIceClass(event) {
    const selectedValue = event.target.value
    this.iceClassTargets.forEach(select => {
      select.value = selectedValue
    })
  }

  syncImoShipType(event) {
    const selectedValue = event.target.value
    this.imoShipTypeTargets.forEach(select => {
      select.value = selectedValue
    })
  }

  stopDropdownClick(event) {
    const clicked = event.target
    // Only stop propagation if it's not a `.button`
    if (!clicked.closest('.button')) {
      event.stopPropagation()
    }
  }
}
